import React, { createContext, useContext, useState } from "react";
import "./loading.scss";

const LoadingContext = createContext(null);

export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);

  const showLoading = () => {
    setLoading(true);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  return (
    <LoadingContext.Provider
      value={{
        loading,
        showLoading,
        hideLoading,
      }}
    >
      {children}

      {loading && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-white backdrop-blur-md">
          <div className="flex flex-col items-center">
            {/* Loading Icon */}
            <div className="relative flex h-16 w-16 items-center justify-center">
              <div className="absolute inset-0 animate-spin rounded-full border border-stone-200 border-t-stone-900" />

              <div className="absolute inset-2 rounded-full border border-stone-100" />

              <div className="h-2 w-2 animate-pulse rounded-full bg-stone-900" />
            </div>

            {/* Text */}
            <div className="mt-6 text-center">
              {/* <p className="text-[11px] font-medium tracking-[0.35em] text-stone-900">
                PROCESSING
              </p> */}

              <p className="mt-2 text-[10px] tracking-wide text-stone-400">
                Please wait a moment
              </p>
            </div>

            {/* Progress */}
            <div className="mt-5 h-px w-32 overflow-hidden bg-stone-200">
              <div className="h-full w-1/2 animate-[loading_1.4s_ease-in-out_infinite] bg-stone-900" />
            </div>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  return useContext(LoadingContext);
}
